export default __webpack_public_path__ + "static/img-media-logo-570ac56c399f710359867a01fc7043dc.avif";